import React, { Component } from "react";

import FormatUtils from "../../utils/formatUtils";

class OtherServiceRequestsBody extends Component {
  render() {
    return (
      <div>
        <div className={"communications-title"}>
          <span>{this.props.data.Title}</span>
        </div>
        <div className={"clear communications-desc"}>
          <span>{this.props.data.Data.Description}</span>
        </div>
        <div className={"communications-data"}>
          <div className="data-line">
            <span className={"key-data"}>
              {this.props.data.Data["Status"] === "Requested"
                ? "Requested Date"
                : "Completed Date"}
            </span>
            <span className="value-data float-right">
              {FormatUtils.formatDate(this.props.data.Date)}
            </span>
          </div>
          <div className="data-line">
            <span className={"key-data"}>Status</span>
            <span className="value-data float-right">
              {this.props.data.Data["Status"]}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default OtherServiceRequestsBody;
